import { CompanyDTO, MembershipDTO } from '../dto/CompanyDTO';
import { CompanySettings } from '@domain/account/models/Company';
import { ApiClient } from '../../ApiClient';

export class CompanyDataSource {

    constructor(
        private apiClient: ApiClient
    ) { }

    async getCompanies(
        page: number = 0,
        limit: number = 25,
        search?: string,
        subscriptionStatuses?: string[]
    ): Promise<CompanyDTO[]> {
        const params = new URLSearchParams({
            page: String(page),
            limit: String(limit),
        });
        if (search) params.set('search', search);
        if (subscriptionStatuses && subscriptionStatuses.length > 0) {
            params.set('subscriptionStatuses', subscriptionStatuses.join(','));
        }

        const response = await this.apiClient.get<CompanyDTO[]>(
            `/companies?${params.toString()}`
        );
        return response.data;
    }

    async getCompany(id: string): Promise<CompanyDTO> {
        const response = await this.apiClient.get<CompanyDTO>(
            `/companies/${id}`
        );
        return response.data;
    }

    async getUserMemberships(): Promise<MembershipDTO[]> {
        const result = await this.apiClient.get<MembershipDTO[]>(
            `/companies/memberships`
        );

        if (result.data.length === 0) throw new Error('No memberships found');

        return result.data;
    }

    async getSettings(): Promise<CompanySettings> {
        const response = await this.apiClient.get<CompanySettings>('/companies/settings');
        return response.data;
    }

    async updateSettings(settings: Partial<CompanySettings>): Promise<CompanySettings> {
        const response = await this.apiClient.patch<CompanySettings>(
            '/companies/settings',
            settings
        );
        return response.data;
    }
}
